import axios from 'axios';
import { SmsTemplate, SmsTemplateCreate, SmsTemplateUpdate } from '@/types/sms';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://neokartuatbak.cholainsurance.com';

export const smsTemplateService = {
  /**
   * Get all SMS templates with optional filters
   */
  async getTemplates(params?: {
    lob_type?: string;
    sms_type?: string;
    is_active?: boolean;
  }): Promise<SmsTemplate[]> {
    const response = await axios.get(`${API_BASE_URL}/api/sms/templates`, { params });
    return response.data;
  },

  /**
   * Get a specific template by ID
   */
  async getTemplate(id: number): Promise<SmsTemplate> {
    const response = await axios.get(`${API_BASE_URL}/api/sms/templates/${id}`);
    return response.data;
  },

  /**
   * Create a new SMS template
   */
  async createTemplate(data: SmsTemplateCreate): Promise<SmsTemplate> {
    const response = await axios.post(`${API_BASE_URL}/api/sms/templates`, data);
    return response.data;
  },

  /**
   * Update an existing SMS template
   */
  async updateTemplate(id: number, data: SmsTemplateUpdate): Promise<SmsTemplate> {
    const response = await axios.put(`${API_BASE_URL}/api/sms/templates/${id}`, data);
    return response.data;
  },

  /**
   * Delete (deactivate) an SMS template
   */
  async deleteTemplate(id: number): Promise<{ message: string; template_id: number }> {
    const response = await axios.delete(`${API_BASE_URL}/api/sms/templates/${id}`);
    return response.data;
  },
};




